<template>
  <div id="app">
    <nav id="menu">
      <header>
        <nav-bar class="Site-header"></nav-bar>
      </header>
    </nav>
    <main id="panel">
      <div class="nav-button menu no-hover">
        <a @click="openMenu">
          <img src="../static/nav.png" alt="Menu Button">
          <span class="desktop-only"> Menu </span>
        </a>
      </div>

      <div class="columns main-nav-bar" style="margin-bottom: 0 !important;">
        <div class="column is-narrow title full-width-deco">
          <h1>Winnipeg Flowers</h1>
          <p class="title-comp"> Est 1987 </p>
        </div>

      </div>
      <progress-bar></progress-bar>
      <router-view class="Site-content"></router-view>
      <footer class="Site-footer footer">
        <div class="container">
          <div class="columns">

            <div class="column storefront-photo">
              <img src="../static/storefront.png" alt="McDiarmid Flowers Storefront">
            </div>

            <div class="column google-map">
              <iframe class="map" src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2571.3418563942723!2d-97.18402568410089!3d49.873606436640735!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x52ea7479ff419c8b%3A0xd8922f350bd2d8e!2sMcDiarmid+Flowers!5e0!3m2!1sen!2sca!4v1513901559292" frameborder="0" style="border:0" allowfullscreen>
              </iframe>
            </div>

            <div class="column contact-container">
              <div class="hours">
                <p> Mon - Fri: 9:30 - 6:00 <p>
                    <p> Saturday: 10:00 - 3:00 </p>
              </div>

              <div class="address">
                <p> 382 Academy Rd </p>
                <p> 204-489-5949 </p>
                <p> <a href="mailto:mail@winnipegflowers.com"><u>mail@winnipegflowers.com</u></a> </p>
              </div>

              <div class="social-media no-hover">
                <a href="https://www.instagram.com/mcdiarmidflowers">
                  <img src="../static/insta.png" alt="instagram logo">
                </a>

                <a href="https://www.facebook.com/McDiarmidFlowers/">
                  <img src="../static/facebook.png" alt="facebook logo">
                </a>

                <a href="https://twitter.com/McDiarmidFlower">
                  <img src="../static/twitter.png" alt="twitter logo">
                </a>
              </div>
            </div>

          </div>

          <div class="columns footer-links is-desktop">
            <div class="column">
              <router-link to="/payment">Payment Terms</router-link>
            </div>
            <div class="column">
              <router-link to="/privacy">Privacy Policy</router-link>
            </div>
            <div class="column">
              <router-link to="/care-and-handling">Care and Handling</router-link>
            </div>
          </div>
        </div>

      </footer>
    </main>
  </div>
</template>

<style scoped>
.tall {
  min-height: 10em;
}

.map {
  width: 100%;
  height: 100%;
}

#app {
  display: flex;
  min-height: 100vh;
  height: 100%;
  flex-direction: column;
}

.Site-footer .Site-header {
  flex: none;
}

.Site-content {
  flex: 1 0 auto;
  width: 100%;
}

.Site-content::after {
  display: block;
  height: 0;
  visibility: hidden;
}

body {
  width: 100%;
  height: 100%;
}

.slideout-menu {
  position: fixed;
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
  z-index: 0;
  width: 235px;
  overflow-y: scroll;
  -webkit-overflow-scrolling: touch;
  display: none;
}

.slideout-panel {
  position: relative;
  z-index: 1;
}

.slideout-open,
.slideout-open body,
.slideout-open .slideout-panel {
  overflow: hidden;
}

.slideout-open .slideout-menu {
  display: block;
}

.burger {
  margin-left: 0;
}
</style>

<script>
import NavBar from './components/NavBar';
import ErrorModal from './components/ErrorModal';
import ProgressBar from './components/ProgressBar';

let slideout;

export default {
  components: {
    ProgressBar,
    ErrorModal,
    NavBar,
  },
  name: 'app',

  created() {
    this.$store.commit('progress/start');

    Promise.all([
      this.$store.dispatch('auth/getMe'),
      this.$store.dispatch('menu/loadMenus'),
      this.$store.dispatch('cart/load'),
    ]).then(() => {
      this.$store.commit('progress/stop');
    });
  },

  mounted() {
    slideout = new Slideout({
      panel: document.getElementById('panel'),
      menu: document.getElementById('menu'),
      padding: 235,
      tolerance: 70,
    });
  },

  methods: {
    openMenu() {
      slideout.toggle();
    },
  },

  computed: {
    user() {
      return this.$store.state.auth.user;
    },

    menus() {
      return this.$store.state.menu.menus;
    },

    cartCount() {
      if (this.$store.state.cart.cart === null) return 0;

      return this.$store.state.cart.cart.length;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/App.vue